import { useEffect } from 'react';

let locks = 0;

/** Locks page scroll while `active`. Nested overlays share one counter. */
const useScrollLock = (active) => {
  useEffect(() => {
    if (!active) return undefined;
    locks += 1;
    const root = document.documentElement;
    if (locks === 1) {
      root.style.setProperty('--scrollbar-gap', `${window.innerWidth - root.clientWidth}px`);
      root.classList.add('is-locked');
    }
    return () => {
      locks -= 1;
      if (locks === 0) root.classList.remove('is-locked');
    };
  }, [active]);
};

export default useScrollLock;
